import {
  GlobalProgramProps,
  ProgramYearsProps,
} from '@/queries/program/schemas.ts'
import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface ProgramsState {
  programs: GlobalProgramProps[]
  selectedProgram: GlobalProgramProps | null
  programYears: ProgramYearsProps[]
  selectedProgramYear: ProgramYearsProps | null
}

const initialState: ProgramsState = {
  programs: [],
  programYears: [],
  selectedProgram: null,
  selectedProgramYear: null,
}

const programsSlice = createSlice({
  name: 'programs',
  initialState,
  reducers: {
    setPrograms: (state, { payload }) => {
      state.programs = payload
    },
    setSelectedProgram: (state, { payload }) => {
      state.selectedProgram = payload
    },
    setSelectedProgramYear: (state, { payload }) => {
      state.selectedProgramYear = payload
    },
    setProgramYears: (state, { payload }) => {
      state.programYears = payload
    },
    resetSelectedProgramAndYear: (state) => {
      state.selectedProgram = null
      state.selectedProgramYear = null
      ;(state.programYears = []), (state.programs = [])
    },
  },
})

export const selectSelectedProgram = (state: RootState) => {
  const programYear = state.programs.selectedProgramYear
  if (!programYear) {
    throw new Error('Selected program not found')
  }
  return programYear
}

export const {
  setPrograms,
  setSelectedProgram,
  setSelectedProgramYear,
  setProgramYears,
  resetSelectedProgramAndYear,
} = programsSlice.actions
export default programsSlice.reducer
